import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/rootCombinedReducers';
import { loadUser } from '../../redux/user/actions';
import Account from './Account';

const ConnectedAccount = () => {
  const dispatch = useDispatch();
  const { loadingState, data } = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <Account
      loadingState={loadingState}
      reloadAction={() => dispatch(loadUser())}
      user={data}
      loadingComponent={undefined}
      errorComponent={undefined}
      ignoreError={false}
    />
  );
};

export default ConnectedAccount;
